/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";

const on = (
  obj: Document | HTMLElement,
  ...args: Parameters<typeof window.addEventListener>
) => obj.addEventListener(...args);

const off = (
  obj: Document | HTMLElement,
  ...args: Parameters<typeof window.addEventListener>
) => obj.removeEventListener(...args);

export const useClickOutside = <E extends Event>(
  ref: React.RefObject<HTMLElement | null>,
  onClickAway: (event: E) => void,
  active = true
) => {
  const savedCallback = React.useRef(onClickAway);

  React.useEffect(() => {
    savedCallback.current = onClickAway;
  });
  React.useEffect(() => {
    if (active) {
      const handler = (event: E) => {
        const { current: el } = ref;
        if (el instanceof HTMLElement && event.target instanceof HTMLElement) {
          !el.contains(event.target) && savedCallback.current(event);
        }
      };

      on(document, "mousedown", handler as EventListener);

      return () => {
        off(document, "mousedown", handler as EventListener);
      };
    }
  }, [ref, active]);
};
